import { Component, OnInit, Inject } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NavbarService } from '../navbar/navbar.service';

@Component({
  selector: 'app-pdfviewer',
  templateUrl: './pdfviewer.component.html',
  styleUrls: ['./pdfviewer.component.css']
})
export class PdfviewerComponent implements OnInit {
  public pdfurl: string;
  public mimeType: string = 'application/pdf';
  windowheight: any;
  constructor(@Inject(DomSanitizer) private sanitizer: DomSanitizer,
              public navService: NavbarService
    ) {
  }

  ngOnInit() {
    this.navService.hide();
    $('link[rel=stylesheet][href*="/assets/css/viewer/materialize.css"]').remove();
    let windowH = $(window).height();
    $('#pdf_content').css({'height': ($(window).height()) + 'px'});
    this.windowheight = ($(window).height()) + 'px';
    this.pdfurl = localStorage.getItem('saved_pdfurl');
    this.pdfurl = this.pdfurl + '?v=' + Math.random();
    // this.pdfurl = "https://www.google.com";
    // this.pdfurl = "http://mr2-tenantdata-dev.s3.amazonaws.com/mr2-tenantdata-dev/1fb49a58-543f-4352-8164-3711c2d95bb9/quotes/76/10055.pdf";
    console.log('pdf url : ', this.pdfurl);
  }

  public innerHtml() { return this.sanitizer.bypassSecurityTrustHtml(
    '<object height=\'' + this.windowheight + '\' width=\'100%\' data=\'' + this.pdfurl + '\' type=\'' + this.mimeType + '\' class=\'embed-responsive-item\'>' +
    '<embed src=\'' + this.pdfurl + '\' type=\'' + this.mimeType + '\' />' + '</object>'); }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/pdfviewer/pdfviewer.component.ts